import { Injectable } from '@angular/core';
import { MensajeModalService } from './mensaje-modal.service';
import { TipoMensajeModal } from '../enum/enumTipoMensajeModal';
import { CargandoService } from 'src/app/core/services/cargando.service';
import { ModalConfig } from '../models/modal-config.model';

/**
 * Servicio simplificado para mostrar modales de error/información
 * 
 * Uso:
 * 1. Crea un ModalConfig con la configuración deseada
 * 2. Llama a mostrarModal(config)
 * 
 * @example
 * ```typescript
 * const config: ModalConfig = {
 *   mensaje: 'Error al procesar',
 *   tipoAlerta: TipoAlerta.Error,
 *   labelBotonPrimario: 'Entendido',
 *   accionBotonPrimario: AccionBoton.Cerrar
 * };
 * this.errorService.mostrarModal(config);
 * ```
 */
@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(
    private servicioMensajesModal: MensajeModalService,
    private cargandoService: CargandoService
  ) { }

  /**
   * Muestra un modal con la configuración proporcionada
   * Detiene el loading automáticamente
   * 
   * @param config - Configuración completa del modal
   */
  public mostrarModal(config: ModalConfig): void {
    // Detener loading si está activo
    this.cargandoService.cambiarEstadoCargando(false);

    // Mostrar modal con un botón
    if (!config.labelBotonSecundario && !config.labelBotonLink) {
      this.servicioMensajesModal.mostratrModalUnaOpcion(
        config.mensaje,
        TipoMensajeModal.cancelacion,
        config.labelBotonPrimario,
        config.tipoAlerta,
        config.accionBotonPrimario,
        config.mensajeCupo,
        config.statusCode,
        config.exceptionType
      );
      return;
    }

    // Mostrar modal con dos botones
    if (config.labelBotonSecundario && !config.labelBotonLink) {
      this.servicioMensajesModal.mostratrModalMultiopcion(
        config.mensaje,
        TipoMensajeModal.cancelacion,
        config.labelBotonPrimario,
        config.labelBotonSecundario,
        config.tipoAlerta,
        config.accionBotonPrimario
      );
      return;
    }

    // Mostrar modal con botón link
    if (config.labelBotonLink) {
      this.servicioMensajesModal.mostratrModalMultiopcionLink(
        config.mensaje,
        TipoMensajeModal.cancelacion,
        config.labelBotonPrimario,
        config.labelBotonLink,
        config.tipoAlerta,
        config.accionBotonPrimario,
        config.accionBotonSecundario!
      );
      return;
    }
  }

  /**
   * Muestra un modal con redirección
   * 
   * @param config - Configuración del modal (debe incluir url)
   */
  public mostrarModalConRedireccion(config: ModalConfig): void {
    if (!config.url) {
      console.warn('mostrarModalConRedireccion llamado sin URL, usando mostrarModal normal');
      this.mostrarModal(config);
      return;
    }

    this.cargandoService.cambiarEstadoCargando(false);

    this.servicioMensajesModal.mostratrModalUnaOpcionRedirect(
      config.mensaje,
      TipoMensajeModal.cancelacion,
      config.labelBotonPrimario,
      config.tipoAlerta,
      config.accionBotonPrimario,
      config.url
    );
  }
}